/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox, Radio, Space } from 'antd';
import exchanges from "../../common/exchanges";
import exchangesWithParams from "../../common/exchanges-with-params";
import testProfile from "../../common/helpers/test-profile";
import fetchProfileURL from "../../common/helpers/fetch-profile-url";
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
import dex from "../../common/dex";

const { TextArea } = Input;
const CreateBotModal = ({ displayCreateBot, setDisplayCreateBot, onBotCreate, updateSelectedBot }) => {
    const {
        state: { profiles },
    } = useAppContext();
    const [step, setStep] = useState(0);
    const [bot, setBot] = useState({
        name: null,
        description: null,
        host_id: null,
        type: 'marketmaker'
    })
    const [profile, setProfile] = useState({});
    const [newProfile, setNewProfile] = useState({
        name: null,
        exchange: null,
        api_key: null,
        api_secret: null,
        custom_api_url: null,
        custom_websocket_url: null,
        is_sandbox: false
    });
    const [createAction, setCreateAction] = useState(true);
    const [profileBalance, setProfileBalance] = useState()
    const [profileLoading, setProfileLoading] = useState(false)
    const goBack = () => {
        if (step !== 0) {
            setStep(step - 1);
        } else {
            setDisplayCreateBot(false);
        }
    }
    const onClickNext = () => {
        if (step !== 3) {
            if (step == 2) {
                handleConnect();
            } else {
                if (!bot.name) {
                    message.error({ content: 'Enter bot name' })
                } else {
                    setStep(step + 1);
                }

            }
        } else {
            if (!profileBalance?.error) {
                let isNewProfile = false;
                if (newProfile.id !== updateSelectedBot?.host?.id) { isNewProfile = true; }
                onBotCreate({ bot, newProfile, updateSelectedBot, isNewProfile })
                setDisplayCreateBot(false);
            }
        }
    }

    const handleConnect = async () => {
        if (profile.exchange === 'hollaex') {
            if (newProfile.custom_websocket_url.length > 0 && !newProfile.custom_websocket_url.startsWith('ws')) {
                message.error('Websocket Url should start with "ws:", "wss:", or "ws+unix:"')
                return;
            }
        }

        setProfileLoading(true)
        newProfile.exchange = profile.exchange;
        testProfile(newProfile).then(res => {
            delete res.info;
            let newArr = [];
            let hasTotal = false;
            Object.keys(res).forEach(key => {
                if (res?.[key]?.hasOwnProperty('total')) {
                    hasTotal = true;
                    newArr.push({ key, total: res?.[key]?.total })
                }
            })
            if (!hasTotal) {
                setProfileBalance(res);
            } else {
                setProfileBalance(newArr);
            }
            setProfileLoading(false);
        }).catch(err => {
            console.log({ err })
            setProfileLoading(false);
        })
        setStep(3);
    }

    useEffect(() => {
        if (updateSelectedBot) {
            setBot({
                name: updateSelectedBot.name,
                description: updateSelectedBot.description,
                host_id: updateSelectedBot.host.id,
                type: updateSelectedBot.type
            })
            // setNewProfile({
            //     id: updateSelectedBot.host.id,
            //     name: updateSelectedBot.host.name,
            //     exchange: updateSelectedBot.host.exchange,
            //     api_key: updateSelectedBot.host.api_key,
            //     api_secret: updateSelectedBot.host.api_secret,
            //     token: updateSelectedBot.host.token,
            //     password: updateSelectedBot.host.password,
            //     custom_api_url: updateSelectedBot.host.custom_api_url,
            //     custom_websocket_url: updateSelectedBot.host.custom_websocket_url,
            //     is_sandbox: updateSelectedBot.host.is_sandbox
            // })
            setNewProfile({ ...newProfile, id: updateSelectedBot.host.id, name: updateSelectedBot.host.name })
            setCreateAction(false);
            setProfile(updateSelectedBot.host)
        }
    }, [updateSelectedBot])



    const getProfileUrl = (exchange, sandboxToggled = false) => {
        fetchProfileURL(exchange).then(urls => {
            let isSameFormat = false;
            let hasTest = false;

            if (urls?.api?.rest && urls?.api?.ws) isSameFormat = true;
            if (urls?.test?.rest && urls?.test?.ws) hasTest = true;

            if (isSameFormat) {
                setNewProfile({
                    ...newProfile,
                    ...(!sandboxToggled && { api_key: null }),
                    ...(!sandboxToggled && { api_secret: null }),
                    ...(!sandboxToggled && { password: null }),
                    ...(!sandboxToggled && { token: null }),
                    custom_api_url: (newProfile.is_sandbox && hasTest) ? urls?.test?.rest : urls?.api?.rest,
                    custom_websocket_url: (newProfile.is_sandbox && hasTest) ? urls?.test?.ws : urls?.api?.ws,
                })
            } else {
                setNewProfile({
                    ...newProfile,
                    ...(!sandboxToggled && { api_key: null }),
                    ...(!sandboxToggled && { api_secret: null }),
                    ...(!sandboxToggled && { password: null }),
                    ...(!sandboxToggled && { token: null }),
                    custom_api_url: null,
                    custom_websocket_url: null,
                })
            }
        })
    }
    useEffect(() => {
        if (profile.exchange && createAction) {

            // getProfileUrl(profile.exchange, true)

            setNewProfile({
                ...newProfile,
                custom_api_url: null,
                custom_websocket_url: null,
                ...(profile.exchange === 'hollaex' &&
                {
                    custom_api_url: !newProfile.is_sandbox ? 'https://api.hollaex.com' : 'https://api.sandbox.hollaex.com',
                    custom_websocket_url: !newProfile.is_sandbox ? 'wss://api.hollaex.com/stream' : 'wss://api.sandbox.hollaex.com/stream'
                }
                ),
            })
        }
    }, [newProfile.is_sandbox])


    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayCreateBot} footer={null} onCancel={() => { setDisplayCreateBot(false); }}>

            {step === 0 ?
                <>
                    <div style={{ fontWeight: "600", color: "white" }}>
                        <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="18.278" height="22.472" viewBox="0 0 18.278 22.472">
                            <g id="Group_30" data-name="Group 30" transform="translate(-43.472 -151)">
                                <path id="Path_5804" data-name="Path 5804" d="M256.929,176.36a9.087,9.087,0,0,0-9.139,9.012V193.9a.746.746,0,0,0,.751.741h16.775a.746.746,0,0,0,.751-.741v-8.525a9.087,9.087,0,0,0-9.138-9.012Zm-7.636,9.012a7.593,7.593,0,0,1,7.637-7.531,7.672,7.672,0,0,1,2.678.487,9.246,9.246,0,0,0-7,8.256,3.049,3.049,0,0,0-2.25,2.194h-1.068Zm4.036,2.607a1.541,1.541,0,1,1-1.563,1.541A1.554,1.554,0,0,1,253.329,187.979Zm11.237,5.177H249.293v-2.895h1.067a3.071,3.071,0,0,0,5.936,0h8.269v2.895Zm0-4.376H256.3a3.048,3.048,0,0,0-2.184-2.177,7.788,7.788,0,0,1,7.618-7.078,7.478,7.478,0,0,1,2.835,5.848Zm-3.812-8.048a.734.734,0,0,0-.023,1.047,5.133,5.133,0,0,1,1.463,3.593.751.751,0,0,0,1.5,0,6.6,6.6,0,0,0-1.881-4.617.757.757,0,0,0-1.061-.023Z" transform="translate(-204.318 -21.166)" fill="#fff" />
                                <rect id="Rectangle_20" data-name="Rectangle 20" width="1.828" height="4.021" rx="0.914" transform="translate(53.169 152.462)" fill="#fff" />
                                <rect id="Rectangle_21" data-name="Rectangle 21" width="1.828" height="6.214" rx="0.914" transform="translate(47.686 151)" fill="#fff" />
                            </g>
                        </svg>
                        <span style={{ marginLeft: 5 }}>{updateSelectedBot ? 'Edit bot' : 'Create a new bot'}</span>   </div>
                    <div style={{ color: "white", margin: "30px 0" }}>
                        <label>Name</label>
                        <Input value={bot.name} onChange={(e) => { setBot({ ...bot, name: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Name the bot" />
                    </div>

                    <div style={{ color: "white", margin: "30px 0" }}>
                        <label>Description (optional)</label>
                        <TextArea value={bot.description} onChange={(e) => { setBot({ ...bot, description: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Describe the bots purpose" rows={6} />
                    </div>
                </> :
                step === 1 ?
                    <>
                        <div style={{ fontWeight: "600", color: "white" }}>Select Bot Type</div>
                        <div style={{ color: "grey", marginTop: 10 }}>Set the bot type below. This will determine the bot's objective.</div>
                        <div style={{ color: "white", margin: "30px 0" }}>
                            <div style={{ marginBottom: 10 }}>Bot Type</div>
                            <Radio.Group onChange={(e) => { setBot({ ...bot, type: e.target.value }) }} value={bot?.type}>
                                <Space direction="vertical">
                                    <Radio style={{ color: "white" }} value={'marketmaker'}>Market Maker</Radio>
                                    <Radio style={{ color: "white" }} value={'accumulator'}>Accumulator</Radio>
                                    <Radio style={{ color: "white" }} value={'triangular'}>Triangular</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                    </>
                    :
                    step === 2 ?
                        <>
                            <div style={{ fontWeight: "600", color: "white" }}>
                                <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="16.661" height="19.325" viewBox="0 0 20.661 22.325">
                                    <path id="Path_6002" data-name="Path 6002" d="M242.571,160.189a.3.3,0,0,0-.394,0l-3.39,2.916a.3.3,0,0,0-.105.229v4.143a.3.3,0,0,0,.3.3h2.064a.3.3,0,0,0,.3-.3v-2.394H243.4v2.394a.3.3,0,0,0,.3.3h2.064a.3.3,0,0,0,.3-.3v-4.143a.3.3,0,0,0-.1-.229Zm2.505.273V158.8a.5.5,0,0,0-1.007,0v.793l-1.365-1.174a.5.5,0,0,0-.657,0l-4.629,3.982a.5.5,0,0,0,.656.763l4.3-3.7,4.3,3.7a.5.5,0,0,0,.656-.763Zm7.048-7.347a.735.735,0,0,0-1.359-.2c-.015.026-1.467,2.558-3.892,2.558-2.4,0-3.852-2.531-3.866-2.554a.735.735,0,0,0-.644-.379c-.4,0-.591.266-.794.547-.47.653-1.717,2.387-3.716,2.387-2.4,0-3.852-2.531-3.865-2.554a.736.736,0,0,0-1.362.2c-2.451,11.285,3.259,18.593,9.421,21.668a.735.735,0,0,0,.658,0c6.16-3.075,11.871-10.382,9.42-21.668ZM242.375,173.3c-5.244-2.768-10.007-8.913-8.606-18.267a5.69,5.69,0,0,0,4.085,1.909,5.86,5.86,0,0,0,4.479-2.427,5.969,5.969,0,0,0,4.539,2.427,5.739,5.739,0,0,0,4.107-1.918c1.4,9.36-3.359,15.508-8.6,18.276Z" transform="translate(-232.045 -152.535)" fill="#fff" />
                                </svg>
                                <span style={{ marginLeft: 5 }}> Home base exchange</span></div>
                            <div style={{ color: "grey", marginTop: 10 }}>Set the exchange API profile below. This will be the platform where your bot will execute orders upon.</div>
                            <div style={{ color: "white", margin: "30px 0" }}>
                                <label>Exchange API Profile</label>
                                <Select
                                    showSearch
                                    value={profile.exchange} onChange={(value) => {
                                        setProfile({ ...profile, api_key: null, api_secret: null, password: null, token: null, exchange: value });
                                        // getProfileUrl(value);
                                        setNewProfile({
                                            ...newProfile,
                                            ...(value === 'hollaex' &&
                                                { custom_api_url: 'https://api.hollaex.com', custom_websocket_url: 'wss://api.hollaex.com/stream' }
                                            ),
                                            is_sandbox: false
                                        })

                                    }}
                                    style={{ width: "100%", marginTop: 10 }}
                                    placeholder="Select profile"

                                >
                                    {exchanges.map(x => {
                                        if (!dex.includes(x.value) && x.value !== 'Custom Script') {
                                            return <Option value={x.value}>{x.label}</Option>

                                        }
                                    })}
                                </Select>
                            </div>

                            <div style={{ color: "white", marginTop: 30, marginBottom: 10 }}>
                                <label>Select profile</label>
                                <Select
                                    // value={newProfile?.name || 'new'}
                                    onChange={(value) => {
                                        if (value === 'new') {
                                            setNewProfile({
                                                id: null,
                                                name: null,
                                                exchange: null,
                                                api_key: null,
                                                api_secret: null,
                                                custom_api_url: null,
                                                custom_websocket_url: null,
                                                ...(profile.exchange === 'hollaex' &&
                                                    { custom_api_url: 'https://api.hollaex.com', custom_websocket_url: 'wss://api.hollaex.com/stream' }
                                                ),
                                                is_sandbox: false
                                            })
                                            setCreateAction(true);
                                        } else {
                                            const foundProfile = profiles.find(profile => profile.id === value);
                                            setNewProfile(foundProfile);
                                            setCreateAction(false);
                                        }

                                    }}
                                    style={{ width: "100%", marginTop: 10 }}
                                    placeholder="Select profile"

                                >
                                    <Option value="new">New</Option>
                                    {profiles.map(x => {
                                        if (x.exchange === profile.exchange) {
                                            return <Option value={x.id}>{x.name}</Option>
                                        }
                                    })}
                                </Select>
                            </div>
                            {(profile.exchange && createAction) && <div style={{ color: "white", marginBottom: 30, padding: 10, marginTop: 20 }}>
                                <div style={{ border: "1px solid grey", width: "100%", minHeight: 400, padding: "0 20px" }}>
                                    <h1 style={{ width: 250, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>New {exchanges.find(x => x.value === profile.exchange).label} exchange API profile</h1>
                                    <div style={{ color: "white", marginTop: 10 }}>
                                        <label>Name</label>
                                        <Input value={newProfile.name} onChange={(e) => { setNewProfile({ ...newProfile, name: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Name" />
                                    </div>

                                    {Object.keys(exchangesWithParams).includes(profile.exchange) ?
                                        <>
                                            {exchangesWithParams[profile.exchange].type === 'only' ? <></> :
                                                <>
                                                    <div style={{ color: "white", margin: "30px 0" }}>
                                                        <label>API key</label>
                                                        <Input value={newProfile.api_key} onChange={(e) => { setNewProfile({ ...newProfile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                                    </div>
                                                    <div style={{ color: "white" }}>
                                                        <label>API secret</label>
                                                        <Input value={newProfile.api_secret} onChange={(e) => { setNewProfile({ ...newProfile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                                    </div>

                                                </>
                                            }
                                        </> :
                                        <>
                                            <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>API key</label>
                                                <Input value={newProfile.api_key} onChange={(e) => { setNewProfile({ ...newProfile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                            </div>
                                            <div style={{ color: "white" }}>
                                                <label>API secret</label>
                                                <Input value={newProfile.api_secret} onChange={(e) => { setNewProfile({ ...newProfile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                            </div>

                                        </>

                                    }

                                    {Object.keys(exchangesWithParams).includes(profile.exchange) &&
                                        <div style={{ color: "white", marginTop: 30 }}>
                                            <label>{exchangesWithParams[profile.exchange].label}</label>
                                            <Input value={newProfile[exchangesWithParams[profile.exchange].param]} onChange={(e) => { setNewProfile({ ...newProfile, [exchangesWithParams[profile.exchange].param]: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Password" />
                                        </div>
                                    }
                                    {profile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Custom API Url (Optional)</label>
                                        <Input value={newProfile.custom_api_url} onChange={(e) => { setNewProfile({ ...newProfile, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                    </div>}
                                    {profile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Custom Websocket Url (Optional)</label>
                                        <Input value={newProfile.custom_websocket_url} onChange={(e) => { setNewProfile({ ...newProfile, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                    </div>}

                                    <div style={{ color: "white", marginTop: 15 }}>
                                        <Checkbox checked={newProfile.is_sandbox} style={{ color: "white" }} onChange={(e) => { setNewProfile({ ...newProfile, is_sandbox: e.target.checked }) }}>Sandbox mode </Checkbox>
                                    </div>
                                    <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0", marginTop: 15 }}>
                                        <span onClick={() => { handleConnect() }} style={{ textDecoration: "underline" }} >CONNECT</span>
                                    </div>
                                </div>
                            </div>}
                        </>
                        :
                        <>
                            <div style={{ fontWeight: "600", color: "white" }}>Home base exchange</div>
                            <div style={{ color: "grey", marginTop: 10 }}>Set the exchange API profile below. This will be the platform where your bot will execute orders upon.</div>
                            <div style={{ color: "grey", marginTop: 10 }}>Connect an exchange account by inputting its API details below. You can get these details visiting your API key page on your exchange account.</div>
                            <div style={{ color: "white", margin: "30px 0" }}>
                                <label>Exchange platform</label>
                                <div>- {exchanges.find(x => x.value === newProfile.exchange).label || "-"}</div>
                            </div>

                            <div style={{ color: "white", marginBottom: 30, padding: 10 }}>
                                <div style={{ border: "1px solid grey", width: "100%", maxHeight: 400, padding: "0 20px" }}>
                                    <h1 style={{ width: 200, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>{exchanges.find(x => x.value === newProfile.exchange).label} Balance</h1>
                                    <div style={{ overflowY: "auto", height: 300, marginTop: 10 }}>
                                        {profileLoading && <Spin size="large" />}
                                        {profileBalance && Array.isArray(profileBalance) ?
                                            profileBalance.sort((a, b) => b.total - a.total).map(data => <div style={{ display: "flex", flexDirection: "row", gap: 5, marginBottom: 5 }}>
                                                <div>{data.key}:</div>
                                                <div>{data.total}</div>
                                            </div>)
                                            : profileBalance && Object.keys(profileBalance).map(key => <>
                                                <div>{key}:</div>
                                                <div>{JSON.stringify(profileBalance[key])}</div>
                                            </>)}

                                    </div>
                                </div>
                            </div>
                        </>
            }


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button disabled={step == 2 && !newProfile.exchange && !updateSelectedBot?.id} onClick={() => { onClickNext() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">Next</Button>
            </div>
        </Modal>
    );
};

export default CreateBotModal;